import { NUMBER } from 'common/constants/gridType';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { alphabetGenerator } from 'utilities';
import { largeCurrencyFormat, smallCurrencyFormat } from '../../../../../common/formats/formats';
import { ParserParams, ValueViewerType } from '../../../../../common/types/scalarSpreadsheet';
import GridRowLabel from '../../../../../components/Grid/GridRowLabel';
import { WaterfallSheetColumns } from '../useWaterfallSheetConfig/useWaterfallSheetConfig.types';

const headerClass = 'table-header title-col';
const totalClassRight = 'title-col division-bottom-only division-top-only subtitle cell align-right';
const WaterfallParser = ({ rowConfig, columns }: ParserParams<WaterfallSheetColumns>) => {
  const cells: Record<string, ICell> = {};

  const sumCells: string[] = [];
  const alphabet = alphabetGenerator([], columns.length);
  rowConfig.forEach((row, index) => {
    columns.forEach((column, columnIndex) => {
      const columnLegend = alphabet[columnIndex];
      const key = `${columnLegend}${index + 1}`;
      if (index === 0) {
        let { className } = row;
        let valueViewer;
        if (columnIndex === 0) {
          className = headerClass;
          valueViewer = props =>
            (<GridRowLabel {...props} unitsFormatter={false} currencyFormatter formatterCell />) as ValueViewerType;
        }
        cells[key] = {
          ...row,
          key,
          columnLegend,
          valueViewer,
          value: column.label,
          className,
        };
      } else if (index === rowConfig.length - 1) {
        if (columnIndex === 1) {
          cells[key] = {
            ...row,
            key,
            columnLegend,
            expr: `=SUM(${sumCells.join(',')})`,
            gridType: NUMBER,
            className: totalClassRight,
            format: largeCurrencyFormat,
          };
        } else if (columnIndex === 0) {
          cells[key] = {
            ...row,
            columnLegend,
            key,
          };
        } else {
          cells[key] = {
            key,
            columnLegend,
            value: '',
          };
        }
      } else {
        const className = columnIndex === 0 ? 'row-label' : row.className;
        const value = row[column.keyName];
        const getFormat = () => {
          if (columnIndex === 0) {
            return undefined;
          }
          if (columnIndex === 1) {
            sumCells.push(key);
            return largeCurrencyFormat;
          }
          return smallCurrencyFormat;
        };
        cells[key] = {
          ...row,
          key,
          columnLegend,
          readOnly: true,
          className,
          value,
          gridType: NUMBER,
          format: getFormat(),
        };
      }
    });
  });
  return cells;
};

export default WaterfallParser;
